/** @format */

import classNames from 'classnames';
import PropTypes from 'prop-types';
import {useState} from 'react';

import {IconButton, Icon} from '@sttark/design-system';

export function Alert({positive, title, onClose, children, className, ...props}) {
    const [closed, setClosed] = useState(false);
    const handleClose = () => {
        onClose?.();
        setClosed(true);
    };

    if (closed) return null;

    const bg = positive ? 'bg-alert-positive' : 'bg-alert-negative';
    const icon = positive ? <Icon name={'Info'} /> : <Icon name={'Warning'} />;
    const alertClass = classNames(`content-box d-flex p-3 ${bg}`, className);
    return (
        <div className={alertClass} {...props}>
            <div className="flex-shrink-0 me-2">{icon}</div>
            <div className="flex-grow-1">
                <div className="font-body-bold-md">{title}</div>
                {children}
            </div>
            <div className="flex-shrink-0">
                <IconButton
                    secondary
                    small
                    color="#FFFFFF"
                    icon={'CloseSmall'}
                    onClick={handleClose}
                />
            </div>
        </div>
    );
}

Alert.propTypes = {
    title: PropTypes.string.isRequired,
    positive: PropTypes.bool,
    onClose: PropTypes.func,
    children: PropTypes.node
};

Alert.defaultProps = {
    title: 'Alert title',
    positive: false
};
